/**
 * CatalogoDelegadoPanel
 *
 * Lo que queda en el lugar donde antes vivia un ABM de catalogo.
 *
 * Tres pantallas (Tipos de Proyecto, Industrias, Categorias de herramientas)
 * eran el mismo CRUD de tres campos que se toca una vez por trimestre, y las
 * tres ya estaban cubiertas por tools MCP que el asistente sabe llamar. Se
 * retiraron los formularios; queda este panel para que el admin que llega
 * buscando el boton entienda que no desaparecio la capacidad, cambio la puerta.
 *
 * El panel NO es un estado vacio ni un error: es la instruccion de como se hace
 * ahora, con la frase exacta que hay que decirle al asistente y el boton para
 * abrirlo. El flujo SSO se reusa de useKaneAssistant (no se duplica).
 *
 * @module pages/settings/CatalogoDelegadoPanel
 */

import React from 'react';
import { Card, Button } from 'react-bootstrap';
import useKaneAssistant from '../../hooks/useKaneAssistant';

/** Alto minimo de cualquier target tocable en movil. */
const TAP_TARGET = 44;

/**
 * @param {Object}   props
 * @param {string}   props.titulo    - Que administra el asistente, en una linea.
 * @param {string}   props.intro     - Como se pide. Una linea, sin jerga.
 * @param {string[]} props.ejemplos  - Frases literales para decirle al asistente.
 * @param {string}   [props.nota]    - Donde se ve el resultado del cambio.
 * @param {string}   [props.icono]   - Clase de Bootstrap Icons.
 */
const CatalogoDelegadoPanel = ({
  titulo,
  intro,
  ejemplos = [],
  nota,
  icono = 'bi-tags',
}) => {
  const abrirAsistente = useKaneAssistant();

  return (
    <Card className="modern-card">
      <Card.Body className="p-4">
        <div className="d-flex align-items-start gap-3 mb-3">
          <i
            className={`bi ${icono} text-primary`}
            style={{ fontSize: '1.75rem', lineHeight: 1 }}
            aria-hidden="true"
          />
          <div>
            <h5 className="mb-1">{titulo}</h5>
            <p className="mb-0 text-muted" style={{ fontSize: '0.9375rem' }}>
              {intro}
            </p>
          </div>
        </div>

        {ejemplos.length > 0 && (
          <div className="mb-3">
            <p className="mb-2" style={{ fontSize: '0.9375rem' }}>
              Decile, tal cual:
            </p>
            <ul className="list-unstyled mb-0">
              {ejemplos.map((frase) => (
                <li
                  key={frase}
                  className="bg-light rounded px-3 py-2 mb-2"
                  style={{ fontSize: '0.9375rem' }}
                >
                  <i className="bi bi-chat-quote me-2 text-muted" aria-hidden="true" />
                  {frase}
                </li>
              ))}
            </ul>
          </div>
        )}

        <Button
          variant="primary"
          onClick={abrirAsistente}
          className="d-inline-flex align-items-center justify-content-center px-4"
          style={{ minHeight: TAP_TARGET, minWidth: TAP_TARGET }}
        >
          <i className="bi bi-robot me-2" aria-hidden="true" />
          Abrir el asistente
        </Button>

        {nota && (
          <p className="text-muted mt-3 mb-0" style={{ fontSize: '0.875rem' }}>
            {nota}
          </p>
        )}
      </Card.Body>
    </Card>
  );
};

export default CatalogoDelegadoPanel;
